import styled from 'styled-components';
import { colors } from '../GlobalStyles';
import { ResponsiveConsultingImage } from './ResponsiveImage';

const WhatWeDoContainer = styled.section`
  background: ${colors.white};
  padding: 5rem 2rem;
  min-height: 600px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 4rem 1rem;
    min-height: 500px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

const ImageContainer = styled.div`
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 300px;
    order: -1;
  }

  @media (max-width: 480px) {
    height: 250px;
  }
`;

const TextContent = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: ${colors.textDark};
  margin-bottom: 1.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: ${colors.textGray};
  line-height: 1.6;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export function WhatWeDo() {
  return (
    <WhatWeDoContainer id="about">
      <ContentWrapper>
        <ImageContainer>
          <ResponsiveConsultingImage alt="Professional IT consulting services" />
        </ImageContainer>
        <TextContent>
          <Title>What We Do</Title>
          <Description>
            We are IT consultants with a focus on scalability, cloud architecture, microservices,
            and cutting-edge technology solutions. Our expertise spans from backend development to
            DevOps, helping companies build robust and scalable systems.
          </Description>
          <Description>
            Our long-term goal is to build our own SaaS solutions while continuing to provide
            exceptional consultancy services to our clients.
          </Description>
        </TextContent>
      </ContentWrapper>
    </WhatWeDoContainer>
  );
}
